import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Button,
  FormControl,
  Grid2,
  FormLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useGlobalModalContext } from "../../context/GlobalModalContext";
import { useState } from "react";
import CustomTooltip from "../CustomTooltip";
const EmailMeetingMinuteDialog = ({ emails }) => {
  //console.log('emails', emails);
  const { hideAllModal, hideModal } = useGlobalModalContext();
  const [emailList, setEmailList] = useState(emails);
  const [emailErr, setEmailErr] = useState(false);

  const handleEmailChange = (e) => {
    setEmailList(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailErr(false);
    if (!emailList) {
      setEmailErr(true);
      return;
    }
    hideModal();
  };
  return (
    <Dialog open onClose={hideModal} maxWidth={"md"} fullWidth={true}>
      <DialogTitle>
        <h4 className="font-bold text-center">Email MOM</h4>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={hideModal}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseOutlined />
      </IconButton>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Grid2 container direction={"row"} rowGap={2}>
            <FormControl size="small" fullWidth required error={emailErr}>
              <FormLabel sx={{ fontWeight: "bold" }}>
                Recipient Email(s):
              </FormLabel>
              <TextField
                size="small"
                value={emailList}
                required
                error={emailErr}
                onChange={handleEmailChange}
              />
            </FormControl>
          </Grid2>
          <Grid2 my={2}>
          <CustomTooltip title="Functionality not yet integrated.">
            <Button
              type="submit"
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Send Email
              </Button>
            </CustomTooltip>
          </Grid2>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EmailMeetingMinuteDialog;
